import { render, staticRenderFns } from "./SlackLogs.vue?vue&type=template&id=160c0b43&"
import script from "./SlackLogs.vue?vue&type=script&lang=js&"
export * from "./SlackLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports